import {get} from "../../pages/Docgen/common/network";

const fetchMatterStatus = async () =>{
  const response = await get(`docgen/matter-status`);
  return response;
}

  const fetchApplicationType = async () => {
    const response = await get(`docgen/application-type`);
    return response;
  }

  const fetchEntityStatus = async () => {
    const response = await get(`docgen/entity-status`);
    return response;
  }

  const fetchMatterSubMatterType = async () => {
    const response = await get(`docgen/matter-sub-matter`);
    return response;
  }

  const fetchContinuityType = async () => {
    const response = await get(`docgen/continuity-type`);
    return response;
  }

  const fetchPriorApplicationStatus = async () => {
    const response = await get(`docgen/prior-application-status`);
    return response;
  }

  export {fetchMatterStatus, fetchApplicationType, fetchEntityStatus, fetchMatterSubMatterType, fetchContinuityType, fetchPriorApplicationStatus};